import {Trans} from '@lingui/macro'
import styled from 'styled-components'

import {Inline, Link, Text, tokens} from '@pleo-io/telescope'
import {NewTab, SpeechBubble} from '@pleo-io/telescope-icons'

import {useSupportChat} from '@product-web/external/use-support-chat'

import {usePleoLinks} from './adoption-centre-link-helpers'
import {trackHelpWidgetLinkClick} from './tracking'

const Container = styled(Inline)`
    border-top: ${tokens.borderPrimary};
    padding: ${tokens.spacing16} ${tokens.spacing28};
`

interface Props {
    closeAdoptionCentre: () => void
}

const AdoptionCentreFooter = ({closeAdoptionCentre}: Props) => {
    const {getHelpCentreLink} = usePleoLinks()
    const supportChat = useSupportChat()
    const onChatToUs = async () => {
        closeAdoptionCentre()
        await supportChat.show()
        trackHelpWidgetLinkClick('contact_us')
    }
    return (
        <Container justifyContent="space-between" alignItems="center">
            <Link
                href={getHelpCentreLink()}
                onClick={() => trackHelpWidgetLinkClick('help_centre')}
                target="_blank"
                rel="noopener noreferrer"
            >
                <Text variant="small-subtle" color="shade700">
                    <Trans>Help centre</Trans>
                    {'  '}
                    <NewTab size={12} />
                </Text>
            </Link>
            <Link onClick={onChatToUs}>
                <SpeechBubble size={16} />
                {'  '}
                <Trans>Chat to us</Trans>
            </Link>
        </Container>
    )
}

export default AdoptionCentreFooter
